<script>
export default {
  name: 'ThuxButtonEditMixin',
  computed: {
    showDetailButton () {
      return false
    }
  }
}
</script>
